import request from '@/utils/request';

// 获取事故列表
export function getAccidentList(data, params) {
  return request({
    url: '/accident/list',
    method: 'post',
    params,
    data
  });
}

// 获取当日事故列表
export function getTodayAccidentList(params) {
  return request({
    url: '/accident/list/today',
    method: 'get',
    params,
  });
}

// 导出事故列表
export function exportAccidentList(data, params) {
  return request({
    url: '/accident/list/export',
    method: 'post',
    params,
    data,
    responseType: 'blob'
  });
}

// 数据请求方法
export function req (url, method, params) {
  return request({
    url: url,
    method: method,
    params: params
  });
}
// 下载人伤直赔表单
export function woundedExport(params) {
  return request({
    url: `/accidentWounded/woundedExport/${params}`,
    method: 'get',
    responseType: 'blob'
  });
}

// 车辆救援下载
export function carRescueExport(data, params) {
  return request({
    url: '/partyMaintenance/carRescueExport',
    method: 'post',
    params,
    data,
    responseType: 'blob'
  });
}

// 医院所有列表查询
export function getHospitalList(params, data) {
  return request({
    url: '/accident/getHospitalList',
    method: 'post',
    data,
    params
  });
}

// 调解所有列表查询
export function getMediatorList(params, data) {
  return request({
    url: '/mediator/allList',
    method: 'post',
    data,
    params
  });
}

// 调解详情
export function getMediatorInfo(params) {
  return request({
    url: '/mediator/info/'+params,
    method: 'get'
  });
}
// 调解结果
export function createMediatorInfo(data) {
  return request({
    url: '/mediator/create',
    method: 'post',
    data: data
  });
}
// 调解结果
export function createMediatorResult(data) {
  return request({
    url: '/mediator/createMediationResult/',
    method: 'post',
    data: data
  });
}

// 拖修车列表查询
export function getCarRescueList(params, data) {
  return request({
    url: '/accident/getCarRescueList',
    method: 'post',
    data,
    params
  });
}
